<template>
  <v-main class="page-library page-library-details">
    <AppBar extension-height="90px" :title="headerTitle">
      <template #end v-if="!unUseIcon">
        <v-btn icon plain :ripple="false" @click="librarySearch()">
          <IconSearch />
        </v-btn>
        <v-btn icon plain :ripple="false" class="me-n3" @click="libraryLike()">
          <i class="cu-icon-interest on"></i>
        </v-btn>
      </template>

      <div class="flex-fill mx-n5">
        <v-tabs v-model="tab"
                flat center-active slider-size="3"
                class="library-tabs"
                color="text-body"
                @change="readList"
        >
          <v-tab v-for="(item, index) in tabs" :key="index" :ripple="false">
            {{ item.cdNm }}
          </v-tab>
        </v-tabs>
        <v-container fluid class="library-filter">
          <v-menu transition="scroll-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  text
                  :ripple="false"
                  v-bind="attrs"
                  v-on="on"
              >
                {{ filterOptions[filter].name }}
                <img :src="getImage('ic_arrow_right.svg')" class="arrow" />
              </v-btn>
            </template>
            <v-list class="filter-list">
              <v-list-item-group v-model="filter"
                                 @change="scFilter">
                <v-list-item
                    v-for="(option, index) in filterOptions"
                    :key="index"
                    link
                    color="primary"
                >
                  <v-list-item-title>{{ option.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-container>
      </div>
    </AppBar>
    <v-container fluid>
      <v-responsive v-if="isLoading" aspect-ratio="1">
        <Loading :isLoading="isLoading" color="white" absolute />
      </v-responsive>
      <NoData v-else-if="!isLoading && items.length === 0" />
      <v-tabs-items v-else v-model="tab" touchless>
        <v-tab-item
            v-for="(tab, index) in tabs"
            :key="index"
        >
          <h4 class="d-none">{{ tab.cdNm }}</h4>
          <LibraryItemList :items="items[index]"
                           :busy="isLoadingItems[index]"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-main>
</template>
<script>
import store from '@/store'
import { mixinAuth } from '@/mixins'
import LibraryItemList from './LibraryItemList.vue'
import IconSearch from '@/components/icons/Search'

export default {
  name: 'LibraryDetails',
  components: {
    LibraryItemList,
    IconSearch
  },
  mixins: [ mixinAuth ],
  data: () => ({
    isLoading: true,
    isLoadingItems: [true],
    tab: null,
    tabs: [],
    items: [],
    filterOptions: [
      { cd: 'regDt', name: '최신순' },
      { cd: 'inqCnt', name: '조회수' },
      { cd: 'likeCnt', name: '좋아요' }
    ],
    filter: 0,
    // filterCd: 'regDt',
    // typeItem: ''
  }),
  computed: {
    headerTitle () {
      return this.$route.query.title
    },
    unUseIcon () {
      return this.$route.query.uui
    }
  },
  created() {
    this.getCodeList('LB002')
    // this.readList('01')
  },
  activated () {
    // router keep alive 로 cache 중 임으로 params reload = true 이면 재조회
    if (this.$route.params.reload) {
      this.tab = 0
      this.filter = 0
      this.readList()
    //   this.typeItem = undefined
    //   this.initItems()
    }
  },
  methods: {
    librarySearch() {
      // 캐시 사용 - 초기화 조건 설정
      this.$router.push({
        name: 'LibrarySearch',
        params: {
          reload: true.toString()
        }
      })
    },
    libraryLike() {
      this.movePage('/fo/library/interest');
    },
    // initItems() {
    //   this.items = [];
    //   this.readList();
    // },
    // scTabs(cd) {
    //   this.typeItem = cd;
    //   this.initItems();
    // },
    scFilter() {
      // this.filterCd = cd;
      this.readList();
    },
    async getCodeList(cdGrp) {
      this.isLoading = true
      await store.dispatch('getCodeList', this.$_payload({'cdGrp': cdGrp}))
          .then(res => {
            if (res.success) {
              this.tabs = res.data;
              this.tabs.unshift({cd: '', cdNm: '전체'})
            } else {
              console.log(res.msg)
              this.tabs = [];
            }
          })
          .catch(error => {
            console.error(error)
            this.tabs = [];
          })
          .finally(() => {
            this.isLoading = false
            this.readList()
          })
    },
    async readList() {
      if (this.tab === null) return false
      if (this.tabs.length === 0) return false
      let cd = this.tabs[this.tab]['cd']
      this.isLoading = true
      this.$set(this.isLoadingItems, this.tab, true)
      let params = [
        {subject: this.$route.query.sid},
        // {type: this.typeItem},
        {type: cd},
        {searchOrderBy: this.filterOptions[this.filter].cd},
        {searchText: this.$route.query.search},
        {searchTextOption: 'content'}
      ]
      await store.dispatch('getLibraryList', this.$_payload('so', params))
          .then(res => {
            this.items[this.tab] = []
            if (res.success) {
              this.$set(this.items, this.tab, [...res.data.contents])
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
            this.items = []
          })
          .finally(() => {
            this.isLoading = false
            this.$set(this.isLoadingItems, this.tab, false)
          })
    }
  }
}
</script>
